module.exports = __webpack_public_path__ + "img/6D.93a9b3e8.svg";